export function asKey(text: string) {
  return text
    .toLowerCase()
    .split(" ")
    .map((part, index) =>
      index > 0 ? part[0].toUpperCase() + part.slice(1) : part
    )
    .join("");
}
